/**
 * Shared sx for ALL toolbar filter Chips and buttons.
 *
 * Every filter chip, active pill, and the "more filters" icon button
 * should use these values (or the matching CSS vars in theme.js) so
 * the toolbar looks uniform.
 *
 * Merge into Chip sx: `sx={{ ...toolbarChipSx, ...yourOverrides }}`
 */
export const toolbarChipSx = {
  cursor: 'pointer',
  fontWeight: 600,
  height: 32,
  // A chip naming a long field, or a single-select showing a long value, keeps
  // the toolbar's shape instead of pushing its neighbours along; the full text
  // is on the chip's own title.
  '& .MuiChip-label': {
    maxWidth: 240,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  borderRadius: 'var(--button-radius)',
  fontSize: '0.8125rem',
  color: 'var(--text-primary)',
  transition:
    'background-color var(--duration-normal) var(--easing-standard), border-color var(--duration-normal) var(--easing-standard), box-shadow var(--duration-fast) var(--easing-standard)',
  '&.MuiChip-outlined, &.MuiChip-filled': {
    backgroundColor: 'var(--surface-primary)',
    borderColor: 'var(--button-outline-border)',
    border: '1px solid var(--button-outline-border)',
    boxShadow: 'var(--card-shadow-raised)',
  },
  '&.MuiChip-outlined:hover, &.MuiChip-filled:hover': {
    backgroundColor: 'var(--interactive-hover)',
    borderColor: 'var(--button-outline-border-hover)',
    boxShadow: 'var(--card-shadow-raised-hover)',
  },
  '&.MuiChip-outlined:active, &.MuiChip-filled:active': {
    boxShadow: 'var(--card-shadow-raised-active)',
  },
  '& .MuiChip-deleteIcon': {
    color: 'inherit',
    opacity: 0.7,
    '&:hover': { opacity: 1 },
  },
};
